<template>
    <drag-zone class="control-list" :onlyShow="onlyShow" :list="list" @outside="addControl" @sort="handleSort">
        <template v-slot:default="scope">
            <control-preview :onlyShow="onlyShow" :config="scope.item.config" :type="scope.item.type" :id="scope.item.key" @select="selectControl(scope.index)" @remove="removeControl(scope.index)"></control-preview>
        </template>
        <slot name="empty" v-if="list.length <= 0"></slot>
    </drag-zone>
</template>

<script>
    import controlPreview from "./control-preview";
    import dragZone from "../drag-zone";
    import {clone, isEmpty} from "../../common/js/tool";
    import controls from "../../common/js/controls";
    export default {
        name: "control-list",
        components: {
            controlPreview,
            dragZone
        },
        inject: ['setSelect'],
        props: {
            controls: {
                type: Array,
                default() {
                    return []
                }
            },
            onlyShow: Boolean,
        },
        data() {
            return {
                list: [],
                di: null //当前正在拖拽的控件下标
            }
        },
        watch: {
            controls() {
                this.setList();
            }
        },
        computed: {
            select() {
                return this.$store.getters.select;
            }
        },
        created() {
            this.setList();
        },
        methods: {
            setList() {
                let temp = this.controls;
                if(temp) {
                    this.list = this.onlyShow ? temp.filter(item => item.config && item.config.isShow !== false) : [...temp];
                } else {
                    this.list = [];
                }
            },
            handleSort(list) {
                this.list = list;
                this.$emit("change", list);
            },
            addControl(e) {
                let index = e.text * 1, i = e.index;
                let item = clone(controls[index]);
                item.key = Date.now() + '';
                //底部标签栏特殊处理
                if(item.type == 'nav') {
                    this.$emit("nav", item);
                } else {
                    //从左边拖拽到区域内
                    if(isEmpty(i)) {
                        item.checked = null;
                        this.list.push(item);
                    } else {
                        //从左边拖拽到组件元素上
                        this.list.splice(i, 0, item);
                    }
                    this.$emit("change", this.list);
                    this.setSelect(item);
                }
            },
            selectControl(index) {
                if (this.onlyShow) {
                    return;
                }
                let item = this.list[index];
                this.setSelect(item);
            },
            removeControl(index) {
                let item = this.list[index];
                //删除已选择中 清除选中状态
                if(item.key == this.select) {
                    this.setSelect(item);
                }
                this.list.splice(index, 1);
                this.$emit("change", this.list);
            }
        }
    }
</script>

<style scoped lang="less">
    .control-list {
        position: relative;
    }
</style>
